<ng-container *ngIf='!loading, else isLoading'>
  <div class='container'>
    <ng-container *ngIf="!globalConfiguration, else showGlobalConfiguration">
      <div class='row mt--md'>
        <div class='column--12 column-md--4 align-center mx--auto'>
          <img src='{{ CDN_URL }}/admin/images/empty_animated.svg' />
          <p>No global configuration found</p>
        </div>
      </div>
    </ng-container>
    <ng-template #showGlobalConfiguration>
      <ng-container *ngIf="!isProd">
        <div class='row'>
          <div class='column--12 mt--md'>
            <button mat-flat-button color='primary' type='button' (click)="triggerRewardJob()" [disabled]="!canEdit || loading">
              Trigger loyalty reward job
            </button>
            <button class="ml--xs" mat-flat-button color='accent' type='button' (click)="triggerReferralJob()" [disabled]="!canEdit || loading">
              Trigger Referral job
            </button>
          </div>
        </div>
      </ng-container>
      <div class='row'>
        <div class='column--12 mt--md'>
          <button mat-flat-button color='warn' type='button' (click)="triggerMultiLegTrackingSyncJob()" [disabled]="!canEdit || loading">
            Sync MultiLeg Tracking
          </button>
        </div>
      </div>
      <div class='row mt--md'>
        <div class='column--4'>
          <form [formGroup]="globalConfigurationForm" novalidate>
            <div class='row'>
              <div class='column--12'>
                <h4>BYOA</h4>
                <mat-form-field>
                  <mat-label>BYOA Account Charge ($)</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type='number' formControlName='byoaChargeAmount' name='byoaChargeAmount' placeholder='0.00'>
                </mat-form-field>
              </div>
            </div>
            <div class='row'>
              <div class='column--12'>
                <h4>Fraudulent Activity</h4>
                <mat-form-field class='column--12'>
                  <mat-label>Maximum # of Wallet Attempts</mat-label>
                  <input matInput type='number' formControlName='maximumWalletFundAttempts' name='maximumWalletFundAttempts' placeholder='3'>
                </mat-form-field>
                <mat-form-field class='column--12'>
                  <mat-label>Attempt time window (in seconds)</mat-label>
                  <input matInput type='number' formControlName='walletFundTimeWindow' name='walletFundTimeWindow' placeholder='1800'>
                </mat-form-field>
                <div class='row mb--md'>
                  <div class='column--12'>
                    <mat-checkbox class="text--sm" color='primary' formControlName='checkBlacklist'><span class='no-bold text--sm'>Check emails against black list API?</span></mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class='row'>
              <div class='column--12'>
                <h4>Return Centre</h4>
                <mat-form-field class='column--12'>
                  <mat-label>Return Centre Renewal ($)</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type='number' formControlName='returnCentreRenewal' name='returnCentreRenewal' placeholder='0.00'>
                </mat-form-field>
              </div>
            </div>
            <div class='row'>
              <div class='column--12'>
                <h4>Signé Local</h4>
                <mat-form-field class='column--12'>
                  <mat-label>Signe Local margin for reporting (%)</mat-label>
                  <mat-icon matSuffix>%</mat-icon>
                  <input matInput type='number' formControlName='signeLocalMargin' name='signeLocalMargin' placeholder='0.00'>
                </mat-form-field>
                <mat-form-field class='column--12'>
                  <mat-label>Signe Local total margin for courier modifier (%)</mat-label>
                  <mat-icon matSuffix>%</mat-icon>
                  <input matInput type='number' formControlName='signeLocalCourierModifier' name='signeLocalCourierModifier' placeholder='0.00'>
                </mat-form-field>
              </div>
            </div>
            <div class='row'>
              <div class='column--12'>
                <h4>External API</h4>
                <mat-form-field class='column--12'>
                  <mat-label>Minimum amount in wallet needed to ship ($)</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type='number' formControlName='externalApiWalletMinimum' name='externalApiWalletMinimum' placeholder='0.00'>
                </mat-form-field>
                <mat-form-field class='column--12'>
                  <mat-label>Safety margin when determining if shipment is payable by wallet (%)</mat-label>
                  <mat-icon matSuffix>%</mat-icon>
                  <input matInput type='number' formControlName='externalApiWalletSafetyMargin' name='externalApiWalletSafetyMargin' placeholder='0.00'>
                </mat-form-field>
              </div>
            </div>
            <div class='row'>
              <div class='column--12'>
                <h4>Reconciliation Thresholds</h4>
                <mat-form-field class='column--12'>
                  <mat-label>Company threshold for "Needs attention" ($)</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type='number' formControlName='reconNeedsAttentionCompanyThreshold' name='reconNeedsAttentionCompanyThreshold' placeholder='1000'>
                </mat-form-field>
                <mat-form-field class='column--12'>
                  <mat-label>Shipment threshold for "Needs attention" ($)</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type='number' formControlName='reconNeedsAttentionShipmentThreshold' name='reconNeedsAttentionShipmentThreshold' placeholder='250'>
                </mat-form-field>
                <mat-form-field class='column--12'>
                  <mat-label>Minimum total for "Pending (light)" ($)</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type='number' formControlName='reconPendingLightMinTotal' name='reconPendingLightMinTotal' placeholder='25'>
                </mat-form-field>
              </div>
            </div>
            <div class='row'>
              <div class='column--12'>
                <h4>Marketing</h4>
                <div class='row mb--md'>
                  <div class='column--12'>
                    <mat-checkbox class="text--sm" color='primary' formControlName='allowFirstTimeDiscount'><span class='no-bold text--sm'>Allow discount on first shipment promotion?</span></mat-checkbox>
                  </div>
                </div>
                <mat-form-field class='column--12'>
                  <mat-label>First time shipment discount (%)</mat-label>
                  <mat-icon matSuffix>%</mat-icon>
                  <input matInput type='number' formControlName='firstTimeDiscount' name='firstTimeDiscount' placeholder='0'>
                </mat-form-field>

                <h4>ACC Ecommerce Call</h4>
                  <div class='row mb--md'>
                    <div class='column--12'>
                      <mat-checkbox class="text--sm" color='primary' formControlName='stopAccEcommerceCalls'><span class='no-bold text--sm'>Stop ACC ecommerce calls?</span></mat-checkbox>
                    </div>
                  </div>

                <h4>Referrals</h4>
                  <div class='row mb--md'>
                    <div class='column--12'>
                      <mat-checkbox class="text--sm" color='primary' formControlName='allowReferral'><span class='no-bold text--sm'>Allow referrals?</span></mat-checkbox>
                    </div>
                  </div>
                <mat-form-field class='column--12'>
                  <mat-label>Business Account referrals amount ($)</mat-label>
                  <mat-icon matSuffix>$</mat-icon>
                  <input matInput type='number' formControlName='businessReferralAmount' name='businessReferralAmount' placeholder='0'>
                </mat-form-field>
                <!-- Province Overrides Display -->
                <div class="row mt--sm">
                  <div class="column--12">
                    <h4>Loyalty Rewards</h4>

                    <div class='row mb--md'>
                      <div class='column--12'>
                        <mat-checkbox class="text--sm" color='primary' formControlName='allowReward'><span class='no-bold text--sm'>Allow rewards on shipments?</span></mat-checkbox>
                      </div>
                    </div>
                    <mat-form-field class='column--12 mb--md'>
                      <mat-label>Minimum Payout Reward Amount to transfer ($)</mat-label>
                      <mat-icon matPrefix>attach_money</mat-icon>
                      <input matInput type='number' formControlName='minPayoutAmount' name='minPayoutAmount' placeholder='0.00'>
                    </mat-form-field>

                    <!-- Reward by Province  -->
                    <div formArrayName="rewardPercentOverrides">
                      <div *ngFor="let group of rewardOverrides.controls; let i = index" [formGroupName]="i" class="row align--center mb--xs">
                        <!-- Province -->
                        <mat-form-field class="column--6 mb--xs">
                          <mat-label>Province</mat-label>
                          <mat-select formControlName="province">
                            <mat-option *ngIf="group.get('province')?.value === 'default'" [value]="'default'">
                              Default
                            </mat-option>
                            <mat-option *ngFor="let province of provinces" [value]="province.id">
                              {{ province.text }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Reward % -->
                        <mat-form-field class="column--5 mb--xs">
                          <mat-label>Reward %</mat-label>
                          <input matInput type="number" formControlName="percent" placeholder="0" />
                        </mat-form-field>

                        <!-- Remove Button -->
                        <div class="column--1">
                          <button [disabled]="group.get('province')?.value === 'default' || !canEdit" mat-icon-button color="warn" type="button" (click)="removeProvinceOverride(i)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Add Province Dropdown + Button -->
                <div class="row align--center">
                  <div class="column--12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Add Province</mat-label>
                      <mat-select [(value)]="selectedProvinceToAdd">
                        <mat-option *ngFor="let province of availableProvinceOptions" [value]="province.id" (click)="addProvinceOverride()" [disabled]="!canEdit || loading || globalConfigurationForm.invalid">
                          {{ province.text }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>

      </div>
      <div class='row'>
        <div class='column--12 mt--md'>
          <button mat-flat-button color='primary' type='button' (click)="updateGlobalConfiguration()" [disabled]="!canEdit || loading || globalConfigurationForm.invalid">
            Update
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
